export default __webpack_public_path__ + "static/cakesnbakeslahore-86757ab5e6345c23bfbe185a715185da.webp";